import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function Zxf() {
    return (
        <PageLayout>
        <Helmet>
          <title>ZXF Airdrop</title>
          <meta name="description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta name="keywords" content="0xtools script, crypto script, dapp, token creator, smart contract generator" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="ZXF Airdrop" />
          <meta property="og:description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta property="og:image" content="https://0xfactory.com/images/airdrop.png" />
          <meta property="og:url" content="https://0xfactory.com/zxf" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="ZXF Airdrop" />
          <meta name="twitter:description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta name="twitter:image" content="https://0xfactory.com/images/airdrop.png" />
          <meta name="twitter:card" content="0xtools_script" />
        </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">ZXF Airdrop</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={12} xl={12}>
                                <div className="text-center">
                                  <h2>Claim 10,000 ZXF Token</h2>
                                </div>
                                <div className="text-center">
                                  <h2>All tokens are for airdrop — no presale, no whales, no team allocation.</h2>
                                </div>
                                <br/>
                                <div>
                                    ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency, you can also use ZXF in a wide range of applications and use cases.
                                </div>
                                <br/>
                                <div className="text-center">
                                <a href="/downloads"><h2 style={{color:'yellow'}}>Download scripts and get free ZXF tokens</h2></a>
                                <br/>
                                </div>

                                <br/>
                                <div className="text-center">
                                        <img src="images/airdrop.png" alt="airdrop" />
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h2 style={{color:'yellow'}}>Get 10,000 ZXF token per download</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <a href="/downloads"><h1 style={{color:'white'}}>Click here to download</h1></a>
                                </div>
                                <br/>
                                <div><h3>Contract: 0x4f214BF2EBd847b6C990Dd96EE8a76e7aEC5E7CD</h3></div>
                                <br/>
                                <div><h3>PancakeSwap Listing Price: 1 ZXF = $0.00025</h3></div>
                                <br/>
                                <h3>ZXF Tokenomics: </h3>
                                <div>Total Supply: 500,000,000 ZXF</div>
                                <div>Airdrop: 200,000,000 ZXF</div>
                                <div>Liquidity: 200,000,000 (Locked 5 years)</div>
                                <div>Marketing: 50,000,000 </div>
                                <div>Development: 50,000,000 </div>
                                <div>Team: Zero</div>
                                <br/>
                                <h4><a href="https://bscscan.com/token/0x4f214BF2EBd847b6C990Dd96EE8a76e7aEC5E7CD" target="_blank" rel="noreferrer">ZXF on BscScan.com</a></h4>
                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
